import NiceModal, { useModal } from '@ebay/nice-modal-react';
import { Modal } from '@mantine/core';

import { useAddTrafficSource } from '../api/addTrafficSource';
import { Fields } from '../hooks/useTrafficSourceForm';

import { TrafficSourceForm } from './TrafficSourceForm';

type AddModalProps = {
  initialValues: Fields;
};

export const AddModal = NiceModal.create(({ initialValues }: AddModalProps) => {
  const modal = useModal();

  const { mutate, isLoading } = useAddTrafficSource({
    onSuccess: modal.hide,
  });

  return (
    <Modal
      centered
      overlayProps={{ opacity: 0.4, blur: 1.5 }}
      opened={modal.visible}
      onClose={() => modal.remove()}
      title="Новый источник трафика"
    >
      <TrafficSourceForm
        isLoading={isLoading}
        onSubmit={(params) => mutate({ ...params })}
        initialValues={initialValues}
      />
    </Modal>
  );
});
